let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8S3lD")).then(() => parcelRequire('2sxFh'));